import { isEmpty } from "lodash";
import React from "react";
import ProductInfoBlock from "./product-info-block";

interface ProductInfoProps {
  title?: string;
  blocks?: { title?: string; description?: string }[];
}

const ProductInfo: React.FC<ProductInfoProps> = ({ title, blocks }) => (
  <div className="product-info">
    {!isEmpty(title) && <h2 className="product-info__heading">{title}</h2>}
    <div className="masonry">
      {(blocks ?? [])
        .filter((block) => !isEmpty(block.description))
        .map((block, index) => (
          <ProductInfoBlock
            key={`${index}-${block.title}`}
            title={block.title}
            description={block.description}
          />
        ))}
    </div>
  </div>
);

export default ProductInfo;
